/**
 * Safe parse of persisted user (avoids throwing on corrupt localStorage JSON).
 * @returns {object|null}
 */
export function getStoredUser() {
    try {
        const raw = localStorage.getItem('user');
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : null;
    } catch {
        return null;
    }
}
